import React, { useContext, useState, useEffect } from "react";
// import RecordKeepingComponent from "./RecordKeepingComponent";
import style from "../Assets/css/dashboard_component.css";
import HeaderComponent from "./UI/HeaderComponent";
import FooterComponent from "./UI/FooterComponent";
import Tabs from "./UI/Tabs";
import AppContext from "../Store/AppContext";
import UKRecordKeepingAnalyticsComponent from "./UKRecordKeepingAnalyticsComponent";
import UKRecordKeepingReportingComponent from "./UKRecordKeepingReportingComponent";
import UKRecordKeepingAnnexIVOrdersComponent from "./UKRecordKeepingAnnexIVOrdersComponent";
import UKRecordKeepingAnnexIVExecutionsComponent from "./UKRecordKeepingAnnexIVExecutionsComponent";
import UKRecordKeepingRTS24OrdersAndExecutionsComponent from "./UKRecordKeepingRTS24OrdersAndExecutionsComponent";
import UKRecordKeepingRTS22TransactionsComponent from "./UKRecordKeepingRTS22TransactionsComponent";

const UKRecordKeepingDashboardComponent = () => {
  const { regulationCode } = useContext(AppContext);

  // console.log("dashboard :", regulationCode);

  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);
  const DATE_RANGE_STORAGE_KEY = `dateRange:${regulationCode}:EURecordKeeping`;

  const getInitialDateRange = (regulation) => {
    const storageKey = `dateRange:${regulation}:EURecordKeeping`;
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      const [start, end] = JSON.parse(saved);
      return [new Date(start), new Date(end)];
    }
    return [sevenDaysAgo, today];
  };

  const [dateRangeByRegulation, setDateRangeByRegulation] = useState(() => ({
    [regulationCode]: getInitialDateRange(regulationCode),
  }));

  useEffect(() => {
    setDateRangeByRegulation((prev) => {
      if (prev[regulationCode]) return prev;
      return {
        ...prev,
        [regulationCode]: getInitialDateRange(regulationCode),
      };
    });
  }, [regulationCode]);

  const dateRange =
    dateRangeByRegulation[regulationCode] ||
    getInitialDateRange(regulationCode);
  const setDateRange = (nextRange) => {
    // console.log("nextRange :", nextRange);
    // console.log("regulation code", regulationCode);
    setDateRangeByRegulation((prev) => ({
      ...prev,
      [regulationCode]: nextRange,
    }));
  };

  useEffect(() => {
    if (dateRange?.[0] && dateRange?.[1]) {
      localStorage.setItem(DATE_RANGE_STORAGE_KEY, JSON.stringify(dateRange));
    }
  }, [dateRange, DATE_RANGE_STORAGE_KEY]);

  return (
    <>
      <HeaderComponent visibility={true} />
      <div style={{ justifyContent: "space-between" }}>
        <Tabs keepMounted>
          <div className={style.tab1} label="Analytics">
            <UKRecordKeepingAnalyticsComponent
              productCode="P001"
              regulationCode={regulationCode}
              dateRange={dateRange}
              setDateRange={setDateRange}
            />
          </div>

          <div className="tab2" label="Reporting">
            <UKRecordKeepingReportingComponent
              productCode="P001"
              regulationCode={regulationCode}
            />
          </div>
          <div className="tab2" label="Annex IV - Orders">
            <UKRecordKeepingAnnexIVOrdersComponent
              productCode="P001"
              regulationCode="R002"
              dateRange={dateRange}
              setDateRange={setDateRange}
            />
          </div>
          <div className="tab2" label="Annex IV - Executions">
            <UKRecordKeepingAnnexIVExecutionsComponent
              productCode="P001"
              regulationCode="R003"
              dateRange={dateRange}
              setDateRange={setDateRange}
            />
          </div>
          <div className="tab2" label="RTS24 - Orders and Executions">
            <UKRecordKeepingRTS24OrdersAndExecutionsComponent
              productCode="P001"
              regulationCode="R001"
              dateRange={dateRange}
              setDateRange={setDateRange}
            />
          </div>
          <div className="tab2" label="RTS22 - Transactions">
            <UKRecordKeepingRTS22TransactionsComponent
              productCode="P001"
              regulationCode="R004"
            />
          </div>
        </Tabs>
      </div>
      <FooterComponent />
    </>
  );
};

export default UKRecordKeepingDashboardComponent;
